module.exports = __webpack_public_path__ + "img/vol05_character_name2.5915d718.png";